import React from 'react';
import Button3D from '../../ui/Button3D';
import { cutoffLine, isSafeBookingUrl, stayLine } from './hotelBlock';

// Module 19 (BL-380) G6 - "Hotel & travel" on the event's Guests & RSVP screen: the hotel block (when Hotel & Travel > hotel block is on)
// and how many guests need the shuttle (when the shuttle question is on). Planners edit; everyone else reads.
export default function HotelTravelPanel({ block, showHotel, showShuttle, shuttle, canEdit, onEdit }) {
    if (!showHotel && !showShuttle) return null;
    return (
        <section className="ia-d2-card space-y-2" aria-label="Hotel and travel" data-testid="hotel-travel">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <h3 className="text-sm font-bold uppercase tracking-wide">Hotel &amp; travel</h3>
                {showHotel && canEdit && <Button3D variant="pill" onClick={onEdit} data-testid="hotel-edit">{block ? 'Edit hotel block' : 'Add hotel block'}</Button3D>}
            </div>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-[minmax(0,1fr)_auto]">
                {showHotel && (
                    <div className="min-w-0 text-sm" data-testid="hotel-summary">
                        {block ? (
                            <>
                                <div className="break-words text-base font-semibold">🏨 {block.hotel_name}</div>
                                {block.hotel_address && <div className="break-words">{block.hotel_address}</div>}
                                {stayLine(block) && <div>{stayLine(block)}</div>}
                                {block.rate_note && <div className="break-words">{block.rate_note}</div>}
                                {cutoffLine(block) && <div className="font-semibold">{cutoffLine(block)}</div>}
                                {block.booking_url && isSafeBookingUrl(block.booking_url) && (
                                    <a className="ia-btn3d ia-btn3d--pill mt-2 inline-flex" href={block.booking_url} target="_blank" rel="noopener noreferrer" data-testid="hotel-link">Open booking link</a>
                                )}
                            </>
                        ) : (
                            <div>No hotel block yet.{canEdit ? ' Add one so guests can book at the group rate.' : ''}</div>
                        )}
                    </div>
                )}
                {showShuttle && (
                    <div className="text-sm sm:text-right" data-testid="shuttle-count">
                        <div className="text-xs font-bold uppercase tracking-wide">Need the shuttle</div>
                        <div className="text-2xl font-bold leading-tight" data-testid="shuttle-count-value">{shuttle}</div>
                        <div>{shuttle === 1 ? 'guest' : 'guests'}, plus-ones included</div>
                    </div>
                )}
            </div>
        </section>
    );
}
